// extracted by mini-css-extract-plugin
export var avatarBone = "_e-4";
export var buttonBone = "_e-3";
export var continueBone = "_e-a";
export var frame = "_e-1";
export var logoBone = "_e-2";
export var pickerGrid = "_e-d";
export var pitchBone = "_e-9";
export var productBone = "_e-8";
export var sectionBone = "_e-7";
export var shell = "_e-0";
export var skeletonPulse = "_e-b";
export var subtitleBone = "_e-6";
export var titleBone = "_e-5";
export var viewport = "_e-c";